import {
  Token,
  createWidget,
  CustomIdentityProvider,
} from '@livechat/widget-core';
import { store } from '@betty/toolkit/store';
import { fetchCustomerToken, setVisibility } from './chat.slice';

export const getCustomIdentityProvider: CustomIdentityProvider = () => {
  let tokenPromise: Promise<Token> | undefined;

  const getToken = async () => {
    if (!tokenPromise) {
      tokenPromise = (async () => {
        const data = await store.dispatch(fetchCustomerToken()).unwrap();

        return data as Token;
      })();
    }

    return tokenPromise;
  };

  return {
    getToken,
    getFreshToken: getToken,
    hasToken: () => Promise.resolve(false),
    invalidate: () => {
      tokenPromise = undefined;

      return Promise.resolve();
    },
  };
};

export const createChatWidget = (license: string, groupId?: number) => {
  const widget = createWidget({
    license,
    ...(groupId !== undefined ? { group: `${groupId}` } : undefined),
    customIdentityProvider: getCustomIdentityProvider,
  });

  widget.init();

  widget.updateEventHandlers({
    onVisibilityChanged({ visibility }) {
      store.dispatch(setVisibility(visibility));
    },
    onNewEvent(event) {
      if (event.author.type === 'agent') {
        widget.updateVisibility('maximized');

        window?.navigator?.vibrate?.(200);
      }
    },
  });

  return widget;
};
